// extracted by mini-css-extract-plugin
export default {"page_wrapper":"style_page_wrapper__WX5Sr","page_main":"style_page_main__vL8JQ","dark":"style_dark__S4acm"};